import { useTranslation } from '@framework/i18n';
import { FlexRow, ISODate, TableData } from '@framework/ui';
import { Space, Typography } from 'antd';
import React from 'react';
import { OrganicoIstitutoDTO } from '../../../../api/employee/schemas';
import { SiapDataColumns } from './SiapDataColumns';

const { Text, Title } = Typography;

export interface ISiapDataTableProps {
  data?: OrganicoIstitutoDTO | null;
  loading?: boolean;
}

/**
 * Componente che riassume tutti i dati SIAP da mostrare
 * all'utente nel widget dedicato.
 */
export function SiapDataTable(props: ISiapDataTableProps) {
  const { data, loading } = props;
  const { t } = useTranslation();

  return (
    <>
      {!loading && data && (
        <>
          <FlexRow
            right={
              <Space>
                <Text strong>
                  {t(
                    'siap-data-table.data-riferimento',
                    'Data di Riferimento',
                  )}
                  :
                </Text>
                <ISODate date={data?.dataRiferimento} format="DD/MM/YYYY" />
              </Space>
            }
          >
            <Space>
              <Text strong>
                {t('siap-data-table.codice-aoo', 'Codice AOO')}:
              </Text>
              <Text>{data?.codAoo}</Text>
            </Space>
          </FlexRow>
          <FlexRow>
            <Space>
              <Text strong>
                {t('siap-data-table.istituto', 'Istituto')}:
              </Text>
              <Text>{data?.istituto}</Text>
            </Space>
          </FlexRow>
          <FlexRow>
            <Space>
              <Text strong>
                {t('siap-data-table.regione', 'Regione')}:
              </Text>
              <Text>{data?.regione}</Text>
            </Space>
          </FlexRow>
        </>
      )}

      <TableData
        size="small"
        dataSource={data?.profili ?? []}
        columns={SiapDataColumns}
        loading={loading}
      />
    </>
  );
}
